
/**
 * Function which takes a property-getting function and tries to return the name of the property it returns.
 *
 * @export
 * @param {(x: any) => any} pathFn - Property-getting function
 * @returns {(string | number | symbol)} Property name
 *
 * @example interface Person {
 *              name: string;
 *              age: number;
 *          }
 *
 * const name = extractPropertyName<Person>(x => x.name);
 * const age = extractPropertyName<Person>(x => x.age);
 * console.log(name, age) // "name, age"
 *
 */
export function extractPropertyName<T extends object>(pathFn: (x: T) => T[keyof T]): keyof T {
    const p = new Proxy<T>({} as T, {
        get(_target, prop): string | number | symbol {
            return prop;
        },
    });
    return <keyof T><unknown>pathFn(p);
}


